<template>
  <div class="panel-navigation">
    <div class="panel-navigation__user" v-if="is_authenticated()">
      <span class="panel-navigation__name">{{ name }}</span>
      <template v-if="availability.total >= 0">
        <div class="panel-navigation__credits">
          <div v-if="availability.is_known">
            <span>credito:</span>
            <strong>€ {{ availability.total }}</strong>
          </div>

          <div v-if="availability.total !== availability.details.integration">
            <span>credito welfare:</span>
            <strong>€ {{ availability.details.integration }}</strong>
          </div>

          <div v-if="availability.details.discount_codes">
            <span>codici sconto:</span>
            <strong>€ {{ availability.details.discount_codes }}</strong>
          </div>
        </div>
      </template>
    </div>

    <navigation class="panel-navigation__menu" />
  </div>
</template>

<script>
import Navigation from './navigation.vue'

export default {
  name: 'panel-navigation',

  components: {
    'navigation': Navigation,
  },

  props: {
    name: String
  },

  data() {
    return {
    }
  },

  computed: {

    availability() {
      return this.get_availability()
    },
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss">

  .panel-navigation {
    position: absolute;
    right: 0;
    top: calc(100% + 15px);
    background-color: $white;
    box-shadow: 0 0 15px 0 rgba(0, 0, 0, .1);
    border-radius: $border-radius-lg * 2;
    padding: $grid-gutter-20;
    min-width: 200px;

    &__user {
      border-bottom: 1px solid $gray-200;
      padding-bottom: $grid-gutter-width / 3;
      line-height: normal;
    }

    &__name {
      font-weight: $vb-font-weight-semibold;
      color: $primary;
    }

    &__credits {
      margin-top: $grid-gutter-width / 6;

      strong {
        margin-left: $grid-gutter-width / 6;
        font-weight: $vb-font-weight-semibold;
        color: $gray-900;
      }
    }
  }

</style>